module.exports = function () {
  var players = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  var help = 'Field Battle';
  var html = "\n      <div class=\"field-battle-overlay\" id=\"field-battle-overlay\">\n\t<div class=\"help\">".concat(help, "</div>\n\t<div class=\"field-battle-grid\">\n\t  <div class=\"attacker\">\n\t    <div class=\"title\">attacker</div>\n\t  </div>\n\t  <div class=\"defender\">\n\t    <div class=\"title\">defender</div>\n\t  </div>\n\t</div>\n\t</div>\n      </div>\n  ");
  return html;
};